import { render } from "./CentroNotificaciones.vue?vue&type=template&id=fbeed0f8&scoped=true"
import script from "./CentroNotificaciones.vue?vue&type=script&lang=js"
export * from "./CentroNotificaciones.vue?vue&type=script&lang=js"

import "./CentroNotificaciones.vue?vue&type=style&index=0&id=fbeed0f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbeed0f8"]])

export default __exports__